import React from 'react';

import TopBar from '../../../containers/Layout/TopBar';


const HeaderComponent = (props) => {
    return( <TopBar Layout={ props.Layout } isHomePage={ props.isHomePage } handleToggleLang={ props.handleToggleLang }/> )
};

export default HeaderComponent;